// src/styles/theme.ts
import { DefaultTheme } from 'styled-components';

/**
 * Color scale
 *  gray050 – card / bubble background
 *  gray100 – overall page background
 *  gray200 – subtle borders / table row separators
 *  gray700 – body text
 *  gray900 – very dark / very light text
 *  heading – branded heading colour (blue in light-mode, gold in dark-mode)
 */

export const lightTheme: DefaultTheme = {
  colors: {
    primary : '#2563eb',
    danger  : '#dc2626',

    heading : '#0a2540',   // dark navy headings

    gray050 : '#ffffff',
    gray100 : '#f3f4f6',
    gray200 : '#e5e7eb',
    gray700 : '#374151',
    gray900 : '#111827',
  },
  radius : '4px',
  spacing: n => `${(n ?? 1) * 0.5}rem`,
};

export const darkTheme: DefaultTheme = {
  colors: {
    primary : '#3b82f6',
    danger  : '#f87171',

    heading : '#fbbf24',   // warm gold headings

    gray050 : '#2b2f37',
    gray100 : '#1f2937',
    gray200 : '#3c424f',
    gray700 : '#dadee7',
    gray900 : '#ffffff',
  },
  radius : lightTheme.radius,
  spacing: lightTheme.spacing,
};
